export default {
  salaryVerification() {
    return {
      Result: 'Success',
      'File Name': '123-2345-2322235-232324(PerfioBankStatement).pdf',
    };
  },
};
